var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: { label: "Done", disabled: _vm.isDisabledSave },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSave
      }
    },
    [
      _c("div", { staticClass: "px-8 pt-8" }, [
        _c(
          "div",
          { staticClass: "mb-1" },
          [
            _vm.title === "create"
              ? _c("BlTextBody2", {
                  attrs: { text: "Create new availability" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col gap-4", style: { width: "40rem" } },
          [
            _c("BlTextTitle4", { attrs: { text: "Custom repeat" } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-2 gap-y-4" },
              [
                _c("BlTextSubtitle3", {
                  staticClass: "my-1",
                  attrs: { text: "Repeat every" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-span-3 flex items-center gap-2" },
                  [
                    _c("BlInputText", {
                      staticClass: "w-16",
                      attrs: { input: _vm.intervalInput, dense: "" },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlSelectBox", {
                      staticClass: "max-w-24",
                      attrs: {
                        placeholder: "Select room",
                        options: _vm.repetitionTypeOptions,
                        dense: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.repetitionTypeInput = $event
                        }
                      },
                      model: {
                        value: _vm.repetitionTypeInput,
                        callback: function($$v) {
                          _vm.repetitionTypeInput = $$v
                        },
                        expression: "repetitionTypeInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.repetitionTypeInput === "week" ||
                _vm.repetitionTypeInput === "month"
                  ? _c("BlTextSubtitle3", {
                      staticClass: "my-1",
                      attrs: { text: "On" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.repetitionTypeInput === "week"
                  ? _c(
                      "div",
                      { staticClass: "col-span-3 flex items-center gap-2" },
                      _vm._l(_vm.daysOfWeekOptions, function(day) {
                        return _c(
                          "button",
                          {
                            key: day.value,
                            staticClass:
                              "outline-none h-8 w-8 flex items-center justify-center rounded-full border",
                            class:
                              _vm.daysOfWeekInput.findIndex(function(i) {
                                return i === day.value
                              }) > -1
                                ? "border-light-purple bg-light-purple"
                                : "border-slate-500 bg-pure-white",
                            attrs: { title: day.value },
                            on: {
                              click: function($event) {
                                return _vm.onChangeDays(day.value)
                              }
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              class:
                                _vm.daysOfWeekInput.findIndex(function(i) {
                                  return i === day.value
                                }) > -1
                                  ? "text-pure-white"
                                  : "text-slate-1000",
                              attrs: { text: day.label }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.repetitionTypeInput === "month"
                  ? _c(
                      "div",
                      { staticClass: "col-span-3 flex items-center" },
                      _vm._l(_vm.onMonthOptions, function(opt, idx) {
                        return _c(
                          "button",
                          {
                            key: opt.input,
                            staticClass:
                              "outline-none h-8 px-3 flex items-center justify-center border border-slate-500",
                            class: [
                              (opt.input === "day" && _vm.dayOfMonthInput) ||
                              (opt.input === "week" && _vm.weekOfMonthInput)
                                ? "bg-slate-300"
                                : "bg-pure-white",
                              idx === 0 ? "rounded-l" : "rounded-r"
                            ],
                            attrs: { title: opt.value },
                            on: {
                              click: function($event) {
                                return _vm.onChangeOnMonth(opt)
                              }
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              class: [
                                (opt.input === "day" && _vm.dayOfMonthInput) ||
                                (opt.input === "week" && _vm.weekOfMonthInput)
                                  ? "text-slate-1000"
                                  : "text-slate-700"
                              ],
                              attrs: { text: opt.label }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("BlTextSubtitle3", { attrs: { text: "Ends" } }),
                _vm._v(" "),
                _c("div", { staticClass: "col-span-3 flex flex-col gap-2" }, [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          name: "repeat_end",
                          checked: _vm.repeatEndInput === "never"
                        },
                        on: {
                          changed: function($event) {
                            _vm.repeatEndInput = "never"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "Never" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          name: "repeat_end",
                          checked: _vm.repeatEndInput === "on_date"
                        },
                        on: {
                          changed: function($event) {
                            _vm.repeatEndInput = "on_date"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "On" } }),
                      _vm._v(" "),
                      _c("BlInputDate", {
                        staticClass: "w-36",
                        attrs: { input: _vm.endAfterInput, dense: "" },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          name: "repeat_end",
                          checked: _vm.repeatEndInput === "after_occurrences"
                        },
                        on: {
                          changed: function($event) {
                            _vm.repeatEndInput = "after_occurrences"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "After" } }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        staticClass: "w-16",
                        attrs: { input: _vm.occurrencesInput, dense: "" },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "time(s)" } })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.repeatEndInput === "never"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "px-4 py-2 bg-cornflower-200 rounded flex items-start gap-2"
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "h-6 w-6",
                      attrs: { icon: "info", color: "cornflower-8" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-cornflower-800",
                          attrs: {
                            text:
                              "If you select 'never ends,' the availability will be generated for up to 6 months, with new slots generated weekly every Sunday at 00:00 WIB (17:00 UTC). Feel free to share any feedback with us at "
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "mailto:blum@simpul.tech",
                              target: "_blank"
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-cornflower-800 underline",
                              attrs: { text: "blum@simpul.tech." }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-141b2b64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-141b2b64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/timeslot/RepeatDetailsModal.vue
// module id = null
// module chunks = 